import { createFileRoute, Link } from "@tanstack/react-router";
import type { JSX } from "react";

import { graphql } from "@repo/graphql-types";
import IllustrationConfetti from "@repo/icons/colored/IllustrationConfetti";

import oldDoctorWithPatient from "@/assets/old-doctor-with-patient.webp";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { Button } from "@/components/ui/button/button";
import { ImageDrawerLayout } from "@/components/ui/layout/image-drawer/image-drawer-layout";
import { useFirstScheduleIntroDestination } from "@/hooks/use-first-schedule-intro-destination";
import { useGraphQL } from "@/hooks/use-graphql";

const AddCardSuccessPageQuery = graphql(/* GraphQL */ `
  query AddCardSuccessPageQuery {
    usuariosCartoes(where: { ativo: { _eq: true } }) {
      numero
    }
  }
`);

const AddCardSuccessPage = (): JSX.Element => {
  const { destination, trackContinue } = useFirstScheduleIntroDestination({
    origin: "cartao_cadastrado",
  });
  const queryData = useGraphQL(AddCardSuccessPageQuery);

  const { data } = queryData;
  const cardData = data?.usuariosCartoes[0]?.numero;
  const lastNumbersText = cardData ? `com final ${cardData.slice(-4)}` : "";

  return (
    <ImageDrawerLayout>
      <ImageDrawerLayout.Image>
        <img
          src={oldDoctorWithPatient}
          alt="Profissional de saúde recebendo paciente na Livance"
          className="w-full h-full object-cover object-top"
        />
      </ImageDrawerLayout.Image>

      <ImageDrawerLayout.Drawer>
        <div className="flex flex-col gap-2">
          <AsyncDataWrapper {...queryData}>
            {data ? (
              <>
                <IllustrationConfetti size={80} aria-hidden="true" />
                <h1 className="text-2xl font-medium text-neutral-700 leading-[1.32]">
                  O cartão {lastNumbersText} foi cadastrado com sucesso!
                </h1>
                <div className="text-base text-neutral-600 font-normal leading-[1.32]">
                  <p>
                    Agora tudo certo para continuar sua jornada na Livance. Siga o passo a
                    passo e agende seus pacientes,
                  </p>
                </div>
              </>
            ) : null}
          </AsyncDataWrapper>
        </div>

        <div className="flex flex-col gap-3">
          <Link {...destination} replace onClick={trackContinue}>
            <Button fullWidth>Continuar</Button>
          </Link>
        </div>
      </ImageDrawerLayout.Drawer>
    </ImageDrawerLayout>
  );
};

export const Route = createFileRoute("/add-payment-card/success")({
  component: AddCardSuccessPage,
});
